import React from 'react';
import {
  HeroContent,
  HeroSectionContent,
  StyleInsideHeader,
} from './NewHeader.styled';

const NewHeader = (props) => {
  return (
    <StyleInsideHeader data-testid='service-page-header'>
      <div
        className='header-overlap-section'
        data-testid='header-overlap-section'
      >
        <HeroSectionContent className='container'>
          <HeroContent>
            <h1 className='chipsStyle'>{props?.data?.source}</h1>
            <span className='headerStyle'>{props.data?.heroHeader}</span>
            <span className='headerStyle2'>{props.data?.heroHeader2}</span>
            <h2 className='highlightHeaderStyle'>
              {props.data.heroSubHeader}{' '}
            </h2>
            <span className='ParaHeaderStyle'>{props.data.heroPara}</span>
          </HeroContent>
        </HeroSectionContent>
      </div>
    </StyleInsideHeader>
  );
};

export default NewHeader;
